import React from "react";
import "./DiscoverMovies.css";
import Loader from "react-loader-spinner";
import {
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { MDBListGroup, MDBListGroupItem, MDBContainer } from "mdbreact";
import { MovieDataContext } from "../../context/discover_data";
import { SortByGenreContext } from "../../context/sortByGenre";
import { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
const DiscoverMovies = (props) => {
  const {
    fetchData,
    info,
    Loading,
    key,
    searchResult,
    searchMovie,
  } = useContext(MovieDataContext);
  const { movieInfo, getGenreList, Id, searchId } = useContext(
    SortByGenreContext
  );
  var mInfo = [];

  useEffect(() => {
    console.log("UseEffect Called");
    if (props.match.params.name) {
      console.log(props.match.params.name);
      fetchData(props.match.params.name);
    } else if (props.match.params.genre) {
      console.log("useEffect Called");
      searchId(props.match.params.genre);
    } else if (props.match.params.search) {
      searchMovie(props.match.params.search);
    }
  }, [
    props.match.params.genre,
    props.match.params.name,
    props.match.params.search,
  ]);
  if (movieInfo.length > 0) {
    mInfo = movieInfo;
    console.log("sort result");
    //  console.log(mInfo)
  } else if (info.length > 0) {
    mInfo = info;
    console.log("info Set")
  } else if (searchResult.length > 0) {
    console.log("search set");
    mInfo = searchResult;
  }
  return (
    <MDBContainer>
    <MDBListGroup>
      <MDBRow size="2">
        {mInfo.length === 0 || Loading === true ? (
          <div className="load">
            <Loader type="BallTriangle" color="blue" height="300" width="300" />
          </div>
        ) : (
          mInfo.map((item, index) => (
            <MDBCol md="4" key={index} >
              <MDBCard
              style={{marginTop:"30px",
              boxShadow: "10px 10px 10px  rgb(191, 192, 194)"
            }}
              >
                <MDBCardImage
                  style={{width:"100%"}}
                  src={`https://image.tmdb.org/t/p/w300/${item.poster_path}`}
                />
                
                <MDBCardBody>
                  <MDBCardTitle>
                    {item.title}
                  </MDBCardTitle>
                  <MDBCardText>
                    {item.overview.split("").splice(0, 50).join("")}....
                  </MDBCardText>
                  <div>
                    {" "}
                    <Link to={`/details/${item.id}`}>
                      <h6>View More </h6>
                    </Link>
                  </div>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          ))
        )}{" "}
      </MDBRow>
    </MDBListGroup>
    </MDBContainer>
  );
};

export default DiscoverMovies;
